// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FinishScheduleCostCodesQueryVariables = Types.Exact<{
  filter: Types.CostCodeFilter;
}>;


export type FinishScheduleCostCodesQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, name: string, finishScheduleOrder?: number | null | undefined, interiorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, finishScheduleOrder: number, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string }> }>, finishScheduleChildItems: Array<{ __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string }, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation } }> }> };

export type SaveFinishScheduleCostCodesMutationVariables = Types.Exact<{
  input: Types.SaveCostCodesInput;
}>;


export type SaveFinishScheduleCostCodesMutation = { __typename?: 'Mutation', saveCostCodes: { __typename?: 'SaveCostCodesResult', costCodes: Array<{ __typename?: 'CostCode', id: string, name: string, finishScheduleOrder?: number | null | undefined, interiorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, finishScheduleOrder: number, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string }> }>, finishScheduleChildItems: Array<{ __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string }, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation } }> }> } };

export type SaveFinishScheduleItemsMutationVariables = Types.Exact<{
  input: Types.SaveItemsInput;
}>;


export type SaveFinishScheduleItemsMutation = { __typename?: 'Mutation', saveItems: Array<{ __typename?: 'Item', id: string, finishScheduleOrder: number }> };

export type FinishScheduleCostCodeFragment = { __typename?: 'CostCode', id: string, name: string, finishScheduleOrder?: number | null | undefined, interiorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, finishScheduleOrder: number, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string }> }>, finishScheduleChildItems: Array<{ __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string }, designPackageLocation: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation } }> };

export const FinishScheduleCostCodeFragmentDoc = gql`
    fragment FinishScheduleCostCode on CostCode {
  id
  name
  finishScheduleOrder
  interiorFinishScheduleLabel
  exteriorFinishScheduleLabel
  items {
    id
    name
    finishScheduleOrder
    designPackageLocation {
      code
    }
    materialAttributeDimensions {
      id
    }
  }
  finishScheduleChildItems {
    id
    name
    costCode {
      id
    }
    designPackageLocation {
      code
    }
  }
}
    `;
export const FinishScheduleCostCodesDocument = gql`
    query FinishScheduleCostCodes($filter: CostCodeFilter!) {
  costCodes(filter: $filter) {
    ...FinishScheduleCostCode
  }
}
    ${FinishScheduleCostCodeFragmentDoc}`;

/**
 * __useFinishScheduleCostCodesQuery__
 *
 * To run a query within a React component, call `useFinishScheduleCostCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleCostCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleCostCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinishScheduleCostCodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables> & ({ variables: FinishScheduleCostCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>(FinishScheduleCostCodesDocument, options);
      }
export function useFinishScheduleCostCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>(FinishScheduleCostCodesDocument, options);
        }
// @ts-ignore
export function useFinishScheduleCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>;
export function useFinishScheduleCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleCostCodesQuery | undefined, FinishScheduleCostCodesQueryVariables>;
export function useFinishScheduleCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>(FinishScheduleCostCodesDocument, options);
        }
export type FinishScheduleCostCodesQueryHookResult = ReturnType<typeof useFinishScheduleCostCodesQuery>;
export type FinishScheduleCostCodesLazyQueryHookResult = ReturnType<typeof useFinishScheduleCostCodesLazyQuery>;
export type FinishScheduleCostCodesSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleCostCodesSuspenseQuery>;
export type FinishScheduleCostCodesQueryResult = ApolloReactCommon.QueryResult<FinishScheduleCostCodesQuery, FinishScheduleCostCodesQueryVariables>;
export const SaveFinishScheduleCostCodesDocument = gql`
    mutation SaveFinishScheduleCostCodes($input: SaveCostCodesInput!) {
  saveCostCodes(input: $input) {
    costCodes {
      ...FinishScheduleCostCode
    }
  }
}
    ${FinishScheduleCostCodeFragmentDoc}`;

/**
 * __useSaveFinishScheduleCostCodesMutation__
 *
 * To run a mutation, you first call `useSaveFinishScheduleCostCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFinishScheduleCostCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFinishScheduleCostCodesMutation, { data, loading, error }] = useSaveFinishScheduleCostCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFinishScheduleCostCodesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFinishScheduleCostCodesMutation, SaveFinishScheduleCostCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFinishScheduleCostCodesMutation, SaveFinishScheduleCostCodesMutationVariables>(SaveFinishScheduleCostCodesDocument, options);
      }
export type SaveFinishScheduleCostCodesMutationHookResult = ReturnType<typeof useSaveFinishScheduleCostCodesMutation>;
export type SaveFinishScheduleCostCodesMutationResult = ApolloReactCommon.MutationResult<SaveFinishScheduleCostCodesMutation>;
export const SaveFinishScheduleItemsDocument = gql`
    mutation SaveFinishScheduleItems($input: SaveItemsInput!) {
  saveItems(input: $input) {
    id
    finishScheduleOrder
  }
}
    `;

/**
 * __useSaveFinishScheduleItemsMutation__
 *
 * To run a mutation, you first call `useSaveFinishScheduleItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFinishScheduleItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFinishScheduleItemsMutation, { data, loading, error }] = useSaveFinishScheduleItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFinishScheduleItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFinishScheduleItemsMutation, SaveFinishScheduleItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFinishScheduleItemsMutation, SaveFinishScheduleItemsMutationVariables>(SaveFinishScheduleItemsDocument, options);
      }
export type SaveFinishScheduleItemsMutationHookResult = ReturnType<typeof useSaveFinishScheduleItemsMutation>;
export type SaveFinishScheduleItemsMutationResult = ApolloReactCommon.MutationResult<SaveFinishScheduleItemsMutation>;